import React from 'react';

export const CalendarIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.25 3.75V6.00002" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M15.75 3.75V6.00002"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.5 5.25H4.5C4.08579 5.25 3.75 5.58579 3.75 6V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V6C20.25 5.58579 19.9142 5.25 19.5 5.25Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M3.75 9.75H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="8.625" cy="13.125" r="0.75" fill="currentColor" />
    <circle cx="12" cy="13.125" r="0.75" fill="currentColor" />
    <circle cx="15.375" cy="13.125" r="0.75" fill="currentColor" />
    <circle cx="8.625" cy="16.5" r="0.75" fill="currentColor" />
    <circle cx="12" cy="16.5" r="0.75" fill="currentColor" />
    <circle cx="15.375" cy="16.5" r="0.75" fill="currentColor" />
  </svg>
);

export const BadgeDot = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="3.5" fill="currentColor" />
  </svg>
);

export const ArrowRightIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.2768 7.46409L8.3393 11.4016C8.21601 11.5249 8.0488 11.5941 7.87445 11.5941C7.7001 11.5941 7.53289 11.5249 7.40961 11.4016C7.28633 11.2783 7.21707 11.1111 7.21707 10.9367C7.21707 10.7624 7.28633 10.5952 7.40961 10.4719L10.2266 7.65604H2.1875C2.01345 7.65604 1.84653 7.5869 1.72346 7.46383C1.60039 7.34076 1.53125 7.17384 1.53125 6.99979C1.53125 6.82574 1.60039 6.65882 1.72346 6.53575C1.84653 6.41268 2.01345 6.34354 2.1875 6.34354H10.2266L7.4107 3.52604C7.28742 3.40276 7.21816 3.23555 7.21816 3.0612C7.21816 2.88685 7.28742 2.71964 7.4107 2.59635C7.53399 2.47307 7.7012 2.40381 7.87555 2.40381C8.0499 2.40381 8.21711 2.47307 8.34039 2.59635L12.2779 6.53385C12.3391 6.5949 12.3876 6.66744 12.4207 6.7473C12.4538 6.82716 12.4707 6.91276 12.4706 6.9992C12.4705 7.08563 12.4534 7.1712 12.4201 7.25098C12.3868 7.33076 12.3381 7.40318 12.2768 7.46409Z"
      fill="currentColor"
    ></path>
  </svg>
);
